import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/sharp-duotone-light-svg-icons";

export const StyledRouteOverviewButton = styled( Button )( {
    flexDirection: "column",
    color: "black",
    minWidth: "15px",
    fontFamily: "Courier monospace",
    fontSize: "18px",
    lineHeight: "1.5",
    "&:hover": {
        backgroundColor: "lightgrey",
    },
} );
export const StyledRenameButton = styled( Button )( {
    flexDirection: "column",
    color: "black",
    padding: "8px",
    marginLeft: "5px",
    minWidth: "15px",
    fontFamily: "Courier monospace",
    fontSize: "18px",
    lineHeight: "1.5",
    "&:hover": {
        backgroundColor: "lightgrey",
    },
} );
export const StyledRouteButtonCaption = styled( Typography )( {
    variant: "caption",
    fontSize: "8px"
} );
export interface ButtonWithLabelProps
{
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    icon: IconDefinition;
    label: string;
}
export function ButtonWithLabel( props: ButtonWithLabelProps ): JSX.Element
{
    return (
        <StyledRouteOverviewButton onClick = {props.onClick}>
            <FontAwesomeIcon icon = {props.icon} size = "sm" fixedWidth/>
            <StyledRouteButtonCaption>{props.label}</StyledRouteButtonCaption>
        </StyledRouteOverviewButton>
    );
}
